import React, { forwardRef } from 'react';
import { cx } from 'linaria';

import { root } from './carousel-item.styles';

const CarouselItem = forwardRef<HTMLLIElement, React.AllHTMLAttributes<HTMLElement>>((props, ref) => {
    const { children, className: classNameProp, ...passThroughProps } = props;
    const className = cx(root, classNameProp);

    return (
        <li ref={ref} className={className} {...passThroughProps}>
            {children}
        </li>
    );
});

CarouselItem.displayName = 'Carousel.Item';

export { CarouselItem };
